import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinnavimumbai() {



    const cardData = {

keyword: "Ertiga On Rent in Navi Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Ertiga On Rent in Navi Mumbai for family travel, airport transfers, corporate trips, local sightseeing, weddings, and outstation journeys. We provide well-maintained Maruti Suzuki Ertiga vehicles with comfortable 6/7 seater capacity, smooth suspension, air-conditioning, ample luggage space, and professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving, we ensure a smooth, budget-friendly, and hassle-free travel experience for every journey.",

topPlaces: [
   
    {
        title: "Nashik",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, temples, and spiritual tourism, making it a frequently visited destination from Navi Mumbai."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a scenic hill station famous for strawberry farms, viewpoints, lakes, and pleasant weather, ideal for family vacations."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s top beach destination known for nightlife, beaches, water sports, and long-distance comfortable Ertiga travel."
    },
     {
        title: "Pune",
        description:
            "Pune is a major IT, education, and business hub near Navi Mumbai, ideal for affordable and comfortable group travel in Ertiga for work and leisure trips."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular hill station known for waterfalls, valleys, caves, and monsoon beauty, making it perfect for family trips and weekend getaways."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a famous pilgrimage destination dedicated to Sai Baba, attracting devotees from across Maharashtra and India throughout the year."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, and traditional Maharashtrian cuisine, attracting both pilgrims and tourists."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, and historical monuments."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal getaway near Mumbai known for beaches, sea forts, and peaceful weekend travel experiences."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a Konkan coastal destination known for Ganpatipule Temple, beaches, and scenic highway drives."
    }
],



services: [
{
name: "Ertiga On Rent in Navi Mumbai",
description: "Ertiga On Rent in Navi Mumbai by 1Touch Cabs offers affordable and comfortable 6–7 seater travel solutions for families, groups, corporate travellers, and airport transfers. We provide well-maintained Maruti Ertiga vehicles driven by professional chauffeurs experienced in city rides and long-distance highway travel. Whether you need local travel, outstation trips, wedding transportation, or daily rentals, our service ensures safe, punctual, and smooth journeys. With spacious seating, air-conditioned comfort, luggage space, transparent pricing, and 24x7 availability, we make group travel in Navi Mumbai easy, economical, and reliable."
},
{
name: "Ertiga Rental Navi Mumbai",
description: "Ertiga Rental Navi Mumbai service provides flexible and budget-friendly transportation for families and small groups. 1Touch Cabs offers clean, comfortable Ertiga vehicles suitable for airport transfers, intercity travel, local rides, and outstation journeys. Our experienced chauffeurs ensure safe driving, timely pickups, and smooth travel experiences. With affordable rental plans, transparent pricing, and easy booking options, we deliver dependable mobility solutions across Navi Mumbai."
},
{
name: "Ertiga Hire in Navi Mumbai",
description: "Ertiga Hire in Navi Mumbai service is ideal for customers seeking spacious and economical travel for family trips, corporate travel, and group transportation. 1Touch Cabs provides well-maintained vehicles with professional drivers, ensuring comfort and safety throughout the journey. Whether for short city trips or long-distance travel, our flexible hire options make transportation simple and convenient."
},
{
name: "Ertiga Car Rental Navi Mumbai",
description: "Ertiga Car Rental Navi Mumbai service offers reliable and comfortable transportation for all travel needs including airport pickups, business trips, family outings, and outstation journeys. 1Touch Cabs ensures clean vehicles, trained chauffeurs, and transparent pricing for a stress-free travel experience. Our focus is on safety, affordability, and customer satisfaction."
},
{
name: "Ertiga Taxi Service Navi Mumbai",
description: "Ertiga Taxi Service Navi Mumbai provides convenient and comfortable 6–7 seater taxi solutions for local and intercity travel. 1Touch Cabs offers professional chauffeurs, clean vehicles, and reliable service for airport transfers, family trips, and group travel. With 24x7 availability and easy booking, we ensure smooth transportation anytime."
},
{
name: "Book Ertiga on Rent in Navi Mumbai",
description: "Book Ertiga on Rent in Navi Mumbai service allows customers to quickly reserve spacious and affordable vehicles for any travel requirement. 1Touch Cabs provides instant booking confirmation, multiple rental options, transparent pricing, and professional chauffeur service. Whether for airport transfers, weddings, or outstation trips, we ensure a seamless booking experience."
},
{
name: "Best Ertiga on Rent Navi Mumbai",
description: "Best Ertiga on Rent Navi Mumbai by 1Touch Cabs ensures top-quality service with clean vehicles, experienced drivers, and comfortable seating for group travel. We focus on safety, punctuality, and affordability, making it ideal for families, corporate groups, and tourists. Our service guarantees a reliable and pleasant travel experience."
},
{
name: "Cheapest Ertiga Rental Navi Mumbai",
description: "Cheapest Ertiga Rental Navi Mumbai service provides budget-friendly 6–7 seater transportation without compromising comfort or safety. 1Touch Cabs offers transparent pricing, well-maintained vehicles, and professional drivers for local and outstation travel. Ideal for families and groups looking for economical travel solutions."
},
{
name: "Ertiga On Rent with Driver Navi Mumbai",
description: "Ertiga On Rent with Driver Navi Mumbai service includes experienced chauffeurs for safe and stress-free travel. 1Touch Cabs ensures professional driving, route knowledge, and punctual service for airport transfers, family trips, and long-distance journeys. Passengers enjoy comfort, safety, and convenience throughout the ride."
},
{
name: "Ertiga Rental Service Navi Mumbai",
description: "Ertiga Rental Service Navi Mumbai provides complete transportation solutions for city travel, airport transfers, and outstation trips. 1Touch Cabs offers flexible rental packages, clean vehicles, and reliable chauffeurs to ensure smooth and comfortable journeys at all times."
},
{
name: "Ertiga Airport Pickup Navi Mumbai",
description: "Ertiga Airport Pickup Navi Mumbai service ensures timely pickup from airports with luggage assistance and professional drivers. 1Touch Cabs tracks flight timings to avoid delays and provides comfortable 6–7 seater vehicles for families and groups arriving in or departing from Navi Mumbai."
},
{
name: "Ertiga Airport Drop Navi Mumbai",
description: "Ertiga Airport Drop Navi Mumbai service offers punctual and reliable transportation to domestic and international airports. 1Touch Cabs ensures safe travel, professional chauffeurs, and comfortable seating for stress-free airport departures."
},
{
name: "Ertiga Outstation Rental Navi Mumbai",
description: "Ertiga Outstation Rental Navi Mumbai service provides affordable long-distance travel for family vacations, business trips, and group tours. 1Touch Cabs offers experienced drivers, clean vehicles, and smooth highway travel for a comfortable journey experience."
},
{
name: "Ertiga Cab for Outstation Navi Mumbai",
description: "Ertiga Cab for Outstation Navi Mumbai service is designed for safe and economical intercity travel. 1Touch Cabs provides reliable chauffeurs, spacious seating, and flexible travel plans for weekend trips, pilgrimages, and long-distance journeys."
},
{
name: "24x7 Ertiga On Rent in Navi Mumbai",
description: "24x7 Ertiga On Rent in Navi Mumbai service ensures round-the-clock availability for all travel needs including emergencies, airport transfers, and late-night journeys. 1Touch Cabs guarantees quick response, professional drivers, and comfortable vehicles anytime you need."
},
{
name: "Late Night Ertiga Rental Navi Mumbai",
description: "Late Night Ertiga Rental Navi Mumbai service provides safe and reliable transportation during late hours with experienced chauffeurs and secure travel options. 1Touch Cabs ensures comfort, punctuality, and safety for night journeys."
},
{
name: "Ertiga On Rent in Mumbai",
description: "Ertiga On Rent in Mumbai service offers affordable group travel solutions across Mumbai and nearby cities. 1Touch Cabs provides clean vehicles, professional drivers, and flexible booking options for city rides, airport transfers, and outstation trips."
},
{
name: "Ertiga Car on Rent in Mumbai",
description: "Ertiga Car on Rent in Mumbai service delivers comfortable and spacious transportation for families and groups. 1Touch Cabs ensures reliable service, transparent pricing, and professional chauffeurs for all types of travel needs."
},
{
name: "Ertiga CNG on Rent in Mumbai",
description: "Ertiga CNG on Rent in Mumbai service provides economical and eco-friendly transportation for daily travel and outstation trips. 1Touch Cabs offers fuel-efficient vehicles, professional drivers, and affordable pricing for cost-effective journeys."
},
{
name: "Ertiga on Hire in Mumbai",
description: "Ertiga on Hire in Mumbai service provides flexible rental options for local, airport, and outstation travel. 1Touch Cabs ensures well-maintained vehicles, experienced chauffeurs, and reliable service for comfortable group transportation."
},
{
name: "Ertiga Rent Per KM in Mumbai",
description: "Ertiga Rent Per KM in Mumbai service offers transparent and flexible pricing based on distance travelled. 1Touch Cabs provides affordable per-kilometre rates, professional drivers, and comfortable vehicles for both local and long-distance travel."
}
],

tableData: [
["Ertiga On Rent in Navi Mumbai","Ertiga Rental Navi Mumbai"],
["Ertiga Hire in Navi Mumbai","Ertiga Car Rental Navi Mumbai"],
["Ertiga Taxi Service Navi Mumbai","Book Ertiga on Rent in Navi Mumbai"],
["Best Ertiga on Rent Navi Mumbai","Cheapest Ertiga Rental Navi Mumbai"],
["Ertiga On Rent with Driver Navi Mumbai","Ertiga Rental Service Navi Mumbai"],
["Ertiga Airport Pickup Navi Mumbai","Ertiga Airport Drop Navi Mumbai"],
["Ertiga Outstation Rental Navi Mumbai","Ertiga Cab for Outstation Navi Mumbai"],
["24x7 Ertiga On Rent in Navi Mumbai","Late Night Ertiga Rental Navi Mumbai"],
["Ertiga On Rent in Mumbai","Ertiga Car on Rent in Mumbai"],
["Ertiga CNG on Rent in Mumbai","Ertiga Rent Per KM in Mumbai"]
],









whychoose: [
    {
        WhyChooseheading: "Reliable Ertiga on Rent in Navi Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Ertiga Rental Services in Navi Mumbai for airport transfers, family vacations, corporate travel, local sightseeing, weddings, and outstation journeys."
    },
    {
        WhyChooseheading: "Spacious 7-Seater Family Vehicle",
        WhyChoosedescription: "Maruti Suzuki Ertiga is one of the most preferred MPVs for family travel, offering comfortable seating, ample luggage space, and a smooth driving experience for local and long-distance journeys." 
    },
    {
        WhyChooseheading: "Perfect for Local and Outstation Travel",
        WhyChoosedescription: "Whether you need transportation within Navi Mumbai or travel to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Kolhapur, Goa, or other destinations, Ertiga is an excellent choice."
    },
    {
        WhyChooseheading: "Affordable and Comfortable Travel Option",
        WhyChoosedescription: "Ertiga rentals are popular among families and groups because they offer an ideal balance of comfort, seating capacity, and economical travel costs." 
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide comfortable Ertiga vehicles for Mumbai Airport and Navi Mumbai Airport transfers with timely pickups and professional chauffeurs." 
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, route expertise, punctual service, and a stress-free travel experience throughout your journey."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby areas."
    },
    {
        WhyChooseheading: "Ideal for Families, Groups, and Corporate Clients",
        WhyChoosedescription: "From family holidays and airport transfers to business travel and group transportation, Ertiga is a practical and comfortable vehicle for every occasion."
    }
]
};

const faqData = [
    {
        question: "Why choose Ertiga on Rent in Navi Mumbai?",
        answer: "Ertiga offers spacious seating for up to 7 passengers, comfortable interiors, good luggage capacity, and affordable travel for both local and outstation trips."
    },
    {
        question: "Can I book an Ertiga for airport transfers?",
        answer: "Yes, Ertiga vehicles are available for Mumbai Airport and Navi Mumbai Airport pickup and drop services." 
    },
    {
        question: "Is Ertiga available for outstation travel?",
        answer: "Yes, customers can hire Ertiga for Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, Kolhapur, and many other destinations." 
    },
    {
        question: "How many passengers can travel in an Ertiga?",
        answer: "Maruti Suzuki Ertiga comfortably accommodates 6 to 7 passengers along with luggage."
    },
    {
        question: "Can corporate clients book Ertiga rentals?",
        answer: "Yes, many corporate organizations and business travelers prefer Ertiga for meetings, employee transportation, and airport transfers."
    },
    {
        question: "Do you provide chauffeur-driven Ertiga rentals?",
        answer: "Yes, all Ertiga bookings from Mumbai Airport Cabs include professional and experienced drivers." 
    },
    {
        question: "Can I hire an Ertiga for family functions and weddings?",
        answer: "Yes, Ertiga is frequently booked for weddings, family events, sightseeing tours, airport transfers, and special occasions."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Can I schedule an Ertiga rental in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book an Ertiga on Rent in Navi Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Salunkhe",
        feedback:
            "We hired an Ertiga for a Shirdi family trip from Navi Mumbai. The vehicle was spacious, comfortable, and the driver ensured a smooth journey throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Bhavana Shah",
        feedback:
            "Our airport transfer and weekend vacation travel were managed perfectly. The Ertiga was clean, well-maintained, and ideal for our family with luggage.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Navi Mumbai",
  "image": "https://www.mumbaiairportcabs.com/assets/images/ertiga-on-rent-navi-mumbai.jpg",
  "description": "Book Ertiga on rent in Navi Mumbai for comfortable family travel, airport transfers, and outstation trips. Mumbai Airport Cabs offers spacious and budget-friendly Ertiga rental service with professional chauffeurs, 24x7 availability, and reliable booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4210"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/ertiga-on-rent-in-navi-mumbai"
  }
};





    return (
        <div>


<Helmet>
  <title>Ertiga on Rent in Navi Mumbai | Affordable Cab Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Ertiga on rent in Navi Mumbai for affordable travel, airport transfers, and outstation trips. Spacious 6/7 seater car with professional drivers and 24x7 service."
  />

  <meta
    name="keywords"
    content="ertiga on rent in navi mumbai, ertiga rental navi mumbai, ertiga hire in navi mumbai, ertiga car rental navi mumbai, ertiga taxi service navi mumbai, book ertiga on rent in navi mumbai, best ertiga on rent navi mumbai, cheapest ertiga rental navi mumbai, ertiga on rent with driver navi mumbai, ertiga airport pickup navi mumbai, ertiga airport drop navi mumbai, ertiga outstation rental navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinnavimumbai;